import Drawer from "react-modern-drawer"
import React, { useEffect, useState } from "react"
import "react-modern-drawer/dist/index.css"
import { twJoin } from "tailwind-merge"
import Link from "next/link"
import { Collapse } from "@components/Collapse/Collapse"
import { headerMobileLinks } from "@layouts/NavigationV2/navigation/headerMobileLinkgs"
import Icon from "@components/UI/Icon"
import { MainButton } from "@components/MainButton/MainButton"
import useUtmTags, { Utm } from "@hooks/useUtmTags";
import RenderIf from "@utils/renderIf";

export const MobileNavigation = ({theme}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState)
  }

  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
      <RenderIf isTrue={isClient}>
        <button
          onClick={toggleDrawer}
          className={twJoin("ml-8 1440:hidden")}
          aria-label={"Menu"}
        >
          <Icon
            name={"burger-open"}
            color="neutral"
            size={32}
            className={theme === "light" ? "fill-neutral-900" : "fill-white"}
          />
        </button>
        <Drawer
          lockBackgroundScroll={true}
          open={isOpen}
          onClose={toggleDrawer}
          direction="right"
          className={twJoin(
              "!w-full max-w-[480px]",
              theme==='light' ? "!bg-white" : "!bg-neutral2-900",
              "overflow-auto",
              "flex flex-col justify-between"
          )}
        >
          <div>
            <header className={twJoin("flex justify-between", "p-24p")}>
              <div className={twJoin(
                  "text-20p font-600 text-slate-blue-300",
                  "[.light_&]:text-violet-500"
              )}>Log In</div>
              <button
                className={"h-32p"}
                onClick={toggleDrawer}
                aria-label={"Close"}
              >
                <Icon
                  name={"cross-icon"}
                  color={theme === "light" ? "neutral-900" : "neutral-100"}
                  size={32}
                  className={""}
                />
              </button>
            </header>
            <div className={twJoin(
                "px-24p",
                "[.neutral_&]:bg-white"
            )}>
              {headerMobileLinks.map((item, index) => {
                if (!item?.subItems) {
                  return (
                    <Link
                      href={item.href}
                      key={`${item.title}-${index}`}
                      className={twJoin(
                          "text-20p font-600 text-white",
                          "[.neutral_&]:text-neutral-700",
                          "[.light_&]:text-neutral-700",
                          "flex",
                          "py-16p",
                          "border-b border-neutral-700",
                          "[.neutral_&]:border-neutral-300",
                          "[.light_&]:border-neutral-300"
                      )}
                    >
                      {item.title}
                    </Link>
                  )
                }

                return (
                  <Collapse
                    key={`${item.title}-${index}`}
                    title={item.title}
                    titleClassName={"[.neutral_&]:text-neutral-700 [.light_&]:text-neutral-700"}
                    iconClassName={"[.neutral_&]:[&_path]:fill-neutral-700 [.light_&]:[&_path]:fill-neutral-700"}
                    contentClassName={"[.neutral_&]:border-neutral-300 [.light_&]:border-neutral-300"}
                    isOpen={openIndex === index}
                    onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                    theme={theme}
                  >
                    <div className={twJoin("flex flex-col gap-24p pb-24p")}>
                      {item.href && (
                        <Link
                          href={item.href}
                          className={twJoin("text-16p font-600 text-white",
                              "[.neutral_&]:text-neutral-700  [.light_&]:text-neutral-700",
                              "flex flex-row items-center gap-12p"
                          )}
                        >
                          {item.icon && (
                            <Icon
                              name={item.icon}
                              color={theme!=="dark" ? "neutral-700" : "neutral-100"}
                              className={twJoin()}
                              size={24}
                            />
                          )}
                          {item.title}
                        </Link>
                      )}
                      {item.description && (
                        <div className={"font-400 text-14p text-neutral2-400 [.neutral_&]:text-neutral-700 [.light_&]:text-neutral-700"}>{item.description}</div>
                      )}
                      {item.subItems.map((subItem, subIndex) => {
                        if (!subItem.href) {
                          return (
                            <div
                              key={`${subItem.title}-${subIndex}`}
                              className={twJoin(
                                "text-14p leading-20p font-500 text-neutral2-300",
                                "[.neutral_&]:text-neutral-700",
                                "[.light_&]:text-neutral-700",
                                "flex flex-row items-center gap-12p"
                              )}
                            >
                              <Icon
                                name={subItem.icon}
                                color={theme!=="dark" ? "neutral-700" : "neutral-100"}
                                size={24}
                                className={""}
                              />
                              {subItem.title}
                            </div>
                          )
                        }
                        return (
                          <div key={subItem.title}>
                            <Link
                              href={subItem.href}
                              key={`${subItem.title}-${subIndex}`}
                              className={twJoin("text-16p font-600 text-white",
                                  "[.neutral_&]:text-neutral-700",
                                  "[.light_&]:text-neutral-700",
                                  "flex flex-row items-center gap-12p")}
                            >
                              {subItem.icon && (
                                <Icon
                                  name={subItem.icon}
                                  color={theme!=="dark" ? "neutral-700" : "neutral-100"}
                                  className={twJoin()}
                                  size={24}
                                />
                              )}
                              {subItem.title}
                            </Link>
                          </div>
                        )
                      })}
                    </div>
                  </Collapse>
                )
              })}
            </div>
          </div>
          <div className={twJoin("px-24p pt-24p pb-100p", "flex flex-col gap-16p")}>
            <MainButton
                href={ useUtmTags(
                    `${ process.env.NEXT_PUBLIC_APP_TRAQQ_URL }/login`,
                    { utm_medium: Utm.MEDIUM.FOOTER, utm_campaign: Utm.CAMPAIGN.BUTTON, utm_term: "Log In"}
                    )}
                size1440={56}
              theme={"primary"}
            >
              Try it completely free
            </MainButton>
            {/*<MainButton
                href={useUtmTags("/demo", { utm_medium: Utm.MEDIUM.FOOTER, utm_campaign: Utm.CAMPAIGN.LINK, utm_term: "Demo"})}
              size1440={56}
              theme={"secondary"}
            >
              Book a demo
            </MainButton>*/}
          </div>
        </Drawer>
      </RenderIf>
  )
}
